import React from "react";
import { InventoryView } from "@components";
export const Inventory = () => {
    return (
        <div>
            <InventoryView />
        </div>
    );
};
